import React from 'react';
import { currencyFormatter } from '../../utils/currencyFormatter';

type PriceRangeProps = {
  className?: string;
  maxPrice?: number;
  minPrice: number;
};

/**
 * Formatted product price range.
 */
const PriceRange = (props: PriceRangeProps) => {
  const { className = '', maxPrice = 0, minPrice = 0 } = props;

  if (minPrice >= maxPrice) {
    const formattedPrice = currencyFormatter(minPrice, { minimumFractionDigits: 0 });
    return <h4 className={className}>{formattedPrice}</h4>;
  }

  const formattedMinPrice = currencyFormatter(minPrice, { minimumFractionDigits: 0 });
  const formattedMaxPrice = currencyFormatter(maxPrice, { minimumFractionDigits: 0 });

  return (
    <h4 className={className}>
      {formattedMinPrice} - {formattedMaxPrice}
    </h4>
  );
};

export default PriceRange;
